import React, { Component } from 'react';
import { connect, batch } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

//Component
import OpenEndedResponse from '../OpenEndedItem/OpenEndedResponse/OpenEndedResponse';
import ItemSection from '../../Section/ItemSection';

import { processResponse, processItemResponse } from '../../../../utilities/processResponse';
// Actions
import { getAnsweredQuestionCount, getQuestionList } from '../../../../actions/SurveyAction';

//Assets
import './OpenEndedItem.css';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';

import { isMobile, isTablet } from 'react-device-detect';
class OpenEndedItem extends Component {
    constructor() {
        super();
        this.state = {
            undoIcon:false,
            naCheck:false
        }

        this.restoreSingleItemArr = [];
    }

    componentDidUpdate(prevProps) {
        var questionId = this.props.scrollToQuestionId;
        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
        }

       // document.body.scrollTop = 0;
        //document.documentElement.scrollTop = 0;
    }

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
            scrollDiv.style.paddingTop = "40px";
            scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
    }

    /**
     * Reset the question options
     *
     */
    resetAll = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch, answeredQuestionCount } = this.props;
        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];
        var nodeList = document.getElementsByClassName(`OpenEnd_${key}`);
        /** Question object  */
        itemList.filter((items, i) => {
            if (items.itemResponses.length > 0) {
                this.restoreSingleItemArr = items.itemResponses;
                this.setState({undoIcon:true});
            }

            var tempArr = this.restoreSingleItemArr.filter((el) => el !== null);

            if (items.key === itemTagKey) {

                if (naType) {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = true;
                            element.value = "";
                        }
                    }
                }
                if (naType === "clear" || typeof naType === "boolean") {
                    items.itemResponses = [];
                    items.isAnswer = false;
                    items.isRequired = false ;

                    if (naType !== "clear") {
                        this.handleNaDisabled(naType, itemTagKey);
                        items.isNA = naType === false ? false : true;
                    }

                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];

                            if (naType !== "clear") {
                                element.disabled = naType ? true : false;
                            } else {
                                element.disabled = false;
                            }
                            element.value = "";
                        }
                    }
                    batch(() => {
                        dispatch(getQuestionList(questionItemList));
                    })
                } else {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = false;
                        }
                    }

                    /** Assign the value of input box */
                    tempArr.map((res, i) => {
                        document.getElementById(`OpenEndedInput_${i+1}`).value = res.userResponseDescription;
                    });

                    // items.userResponse = tempArr;
                    items.itemResponses = tempArr;
                    items.isAnswer = true;
                    items.isNA = false;
                    this.setState({undoIcon:false});
                }
            }
            return true;
        });
        let remainCount = answeredQuestionCount - 1;
        dispatch(getAnsweredQuestionCount(remainCount));
    }

    handleNaDisabled = (naType, itemTagKey) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);
        scrollDiv.style.fontStyle = naType === false ? 'normal' :'italic';
        scrollDiv.style.color = naType === false ? '#0f5ea0' :'#8787';
    }
    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
        return <i className={`fa fa-spinner fa-spin fa_${configuration.key}`} style={{"fontSize":"25px", "display":"none"}}></i>
    }

    renderTextArea(configuration) {
        // const { configuration, questionItemList, pageInstrumentConfiguration } = this.props;
        const { questionItemList, pageInstrumentConfiguration, itemResponses, itemTempResponses, getAllResponses, activePageKey, assessmentInfosForDataCollection, putAllForItemCollection } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey];
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
        let key = this.currentRatee.dataCollectionGuid;

        return (
            <td>
                <OpenEndedResponse
                    key={configuration.key}
                    configuration={scaleResponses}
                    items={configuration}
                    activePageKey={activePageKey}
                    itemResponses={itemResponses}
                    itemTempResponses={itemTempResponses}
                    pageInstrumentConfiguration={pageInstrumentConfiguration}
                    questionItemList={questionItemList}
                    putAllForItemCollection={putAllForItemCollection}
                    rateeKey={key}
                    ratees={assessmentObj}
                    handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
                    getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
                />
            </td>
        );
    }

    renderRatee(ratee, me) {
        const { configuration } = this.props;
        this.currentRatee = ratee;
        this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(":");
        return this.renderTextArea(configuration, this);
    }

    /**
     * N/A check box functionality
     *
     */
    naOpenEndCheck = (event, configuration) => {
        try {
           // const { itemResponses } = this.props;

            var itemKey = configuration.key;
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${itemKey}`);
            this.setState({naCheck:naCheck});
            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";
                var responseSet = this.props.itemResponses[itemKey] = {};
                var itemResponses = [{
                    "itemType"     : configuration.itemType,
                    "buttonGroup"  : null,
                    "sequence"     : 1,
                    "isNa"         : naCheck,
                    "response"     : null,
                    "responseValue": null,
                    "openEnd"      : null,
                    "serverStatus" : 0,
                    "hasPosted"    : 0
                }];
                processItemResponse(itemKey, responseSet, itemResponses);
                this.props.handleItemResponse(configuration.key, this.props.itemResponses, "itemChange");
            } else {
                surveyItem.style.background = "#fff";
                surveyItem.style.color = "#000";
            }

            this.resetAll(null, configuration, null, naCheck);
        } catch (error) {
            console.log("Exception: while check n/a checkbox in single select:_", error);
        }
    }

    /**
     * Restore value before selected
     *
     */
    resetOpenEndResponse = (event, configuration) => {
        this.resetAll(null, configuration, null, "reset");
    }

    renderView = (configuration) => {
        const { questionItemList, pageInstrumentConfiguration, itemResponses, itemTempResponses, getAllResponses, activePageKey, assessmentInfosForDataCollection, dataCollectionGuid } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey];
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        return <OpenEndedResponse
                key={configuration.key}
                configuration={scaleResponses}
                items={configuration}
                activePageKey={activePageKey}
                itemResponses={itemResponses}
                itemTempResponses={itemTempResponses}
                pageInstrumentConfiguration={pageInstrumentConfiguration}
                questionItemList={questionItemList}
                ratees={assessmentObj}
                putAllForItemCollection={this.props.putAllForItemCollection}
                rateeKey={dataCollectionGuid}
                handleItemResponse={(itemKey, itemResponsesSet, type, dataGuidId) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuidId)}
                getResPonsesOnLoad={(itemKey, itemResponseSet, dataGuidId) => this.props.getResPonsesOnLoad(itemKey, itemResponseSet, dataGuidId)}
                handleDependentItem={(itemKey, response, pageDep)=>this.props.handleDependentItem(itemKey, response, pageDep)}
            />
    }

    render() {
        const { configuration, questionItemList, pageInstrumentConfiguration, assessmentInfosForDataCollection } = this.props;
        const { itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, scales, sections, properties } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey];
        const { substitutions } = pageInstrumentConfiguration;

        var jsx = '';
        var rateeKey = null;
        var tempQuestionList = [];
        var naResponse = scales[configuration.scaleKey].naResponse;
        const ratees = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        for (const key in questionItemList) {
            if (questionItemList.hasOwnProperty(key)) {
                const element = questionItemList[key];
                tempQuestionList.push(element)
            }
        }



        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }

        const responseLength = tempQuestionList.filter((item, i) => {
            if (item.key === configuration.key ) {
                return item.userResponse.length || 0;
            }
        });
        let OSName = "Unknown OS";
        if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
        if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
        if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
        if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";

        var groupIconsClass = configuration.hasItemResetButton || configuration.hasItemRestoreButton || naResponse !== null ? "ItemGroupIcon" : null;
        if (ratees.length < 2) {
            jsx = (
                <div data-id={configuration.key} name="survey-item-block" id={`survey-item-block_${configuration.key}`} className={`survey-item-block_${configuration.key}`} style={(isMobile || isTablet) && OSName == "Android" ? {position:'relative', top:29} : null}>
                    <Row id={`ScrollDiv_${configuration.key}`} className={configuration.itemText !== null  && configuration.itemText !== '&nbsp;'? `_ItemTextCss _tempOpenEnd ${configuration.cssClass !== null ? configuration.cssClass:""}` : null}>
                    {
                        configuration.itemText && configuration.itemText !== null && configuration.itemText !== '&nbsp;' ?
                        <>
                            <Col xs={1}>
                                <div className={"ItemSpinner"}>
                                    { configuration.itemText === null ? this.renderSpinner(configuration) : null }
                                </div>
                            </Col>
                            <Col
                                xs={naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? 12 : 10}
                                className="itemText"
                            >
                                {configuration.isRequiredLabel === true ? <span className={"_AsteriskMark"}>{properties.requiredIndicator}</span> :''}
                                <span className="itemTag" dangerouslySetInnerHTML={{__html:configuration.itemTag}}></span>
                                <span dangerouslySetInnerHTML={{__html: processResponse(configuration.itemText, substitutions)}}></span>
                            </Col>

                            <Col
                                xs={1}
                                className={groupIconsClass}
                                style={{display: naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? "block":""}}
                            >
                                {naResponse !== null && naResponse !== undefined ? <span
                                    key={buttons[itemNaUncheckedButtonKey].key}
                                    className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                >
                                    <Form.Check type="checkbox" onChange={(event) => this.naOpenEndCheck(event, configuration)}/> <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {configuration.hasItemResetButton ?
                                    <span
                                        key={buttons[itemResetButtonKey].key}
                                        className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetAll(event, configuration, rateeKey, "clear")}
                                    >
                                        { responseLength.length > 0 && this.state.undoIcon === false ?  <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                :null}
                                { configuration.hasItemRestoreButton ?
                                    <span
                                        key={buttons[itemRestoreButtonKey].key}
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetOpenEndResponse(event, configuration)}
                                    >
                                        { this.state.undoIcon === true && this.state.naCheck === false ?  <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                    :null
                                }
                            </Col>
                        </>:null
                    }
                    </Row>
                    <Row>
                        <Col xs={1}>

                        </Col>
                        <Col xs={11}>
                            {configuration.itemPreSectionKey !== null && sections.hasOwnProperty(configuration.itemPreSectionKey) ?
                                <ItemSection
                                    key={sections[configuration.itemPreSectionKey].key}
                                    type="itemPreSection"
                                    html={sections[configuration.itemPreSectionKey].content}
                                    className={sections[configuration.itemPreSectionKey].className !== null ? sections[configuration.itemPreSectionKey].className:""}

                            />: null}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={1} >
                            <div className={"ItemSpinner"}>
                                { configuration.itemText === null ? this.renderSpinner(configuration) : null }
                            </div>
                        </Col>
                        <Col md={10} className={scaleResponses.renderingHint === "textarea"? "_LIS_OpenEnd":"_WMQ_Word"}>
                            {this.renderView(configuration)}
                        </Col>
                        <Col md={1}></Col>
                    </Row>
                    <Row>
                        <Col xs={1}></Col>
                        <Col xs={10}>
                            {configuration.itemPostSectionKey !== null && sections.hasOwnProperty(configuration.itemPostSectionKey) ?
                                <ItemSection
                                    key={sections[configuration.itemPostSectionKey].key}
                                    type="itemPostSection"
                                    html={sections[configuration.itemPostSectionKey].content}
                                    className={sections[configuration.itemPostSectionKey].className !== null ? sections[configuration.itemPostSectionKey].className:""}
                            />: null}
                        </Col>
                    </Row>
                </div>
            )
        } else {
            jsx = (
                <div id={`survey-item-block_${configuration.key}`} className={"survey-item-block"}>
                     <Row id={`ScrollDiv_${configuration.key}`} className={configuration.itemText !== null  && configuration.itemText !== '&nbsp;'? `_ItemTextCss _tempOpenEnd ${configuration.cssClass !== null ? configuration.cssClass:""}` : null}>
                    {
                        configuration.itemText && configuration.itemText !== null && configuration.itemText !== '&nbsp;' ?
                        <>
                            <Col xs={1}>
                                <div className={"ItemSpinner"}>
                                    { configuration.itemText === null ? this.renderSpinner(configuration) : null }
                                </div>
                            </Col>
                            <Col
                                xs={naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? 12 : 10}
                                className="itemText"
                            >
                                {configuration.isRequiredLabel === true ? <span className={"_AsteriskMark"}>{properties.requiredIndicator}</span> :''}
                                <span className="itemTag" dangerouslySetInnerHTML={{__html:configuration.itemTag}}></span>
                                <span dangerouslySetInnerHTML={{__html: processResponse(configuration.itemText, substitutions)}}></span>
                            </Col>

                            <Col
                                xs={1}
                                className={groupIconsClass}
                                style={{display: naResponse !== null && naResponse !== undefined && configuration.hasItemResetButton && configuration.hasItemRestoreButton ? "block":""}}
                            >
                                {naResponse !== null && naResponse !== undefined ? <span
                                    key={buttons[itemNaUncheckedButtonKey].key}
                                    className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                >
                                    <Form.Check type="checkbox" onChange={(event) => this.naOpenEndCheck(event, configuration)}/> <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {configuration.hasItemResetButton ?
                                    <span
                                        key={buttons[itemResetButtonKey].key}
                                        className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetAll(event, configuration, rateeKey, "clear")}
                                    >
                                        { responseLength.length > 0 && this.state.undoIcon === false ?  <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                :null}
                                { configuration.hasItemRestoreButton ?
                                    <span
                                        key={buttons[itemRestoreButtonKey].key}
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetOpenEndResponse(event, configuration)}
                                    >
                                        { this.state.undoIcon === true && this.state.naCheck === false ?  <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                    :null
                                }
                            </Col>
                        </>:null
                    }
                    </Row>
                    { configuration.isPlaceholder === true ? <div className='PostItemTextDiv'>This is placeholder</div>: null }
                    <div className='OpenEndMultiUserGroup'>
                    <table className="tableColumn">
                        <tbody>
                            {ratees != null ? ratees.map(ratee => {
                                    return (
                                        <tr key={ratee.dataCollectionGuid}>
                                            <td className='RateeName'>
                                                { (ratee.participantFirstName !== null ? ratee.participantFirstName: "") +" "+ (ratee.participantLastName !== null ? ratee.participantLastName: "")}
                                            </td>
                                            {this.renderRatee(ratee, this)}
                                        </tr>
                                    );
                                }, this) : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            )
        }
        return jsx;
    }
}

const mapStateToProps = state => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    assessmentInfosForDataCollection:state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(OpenEndedItem);
